import React from 'react';
import { Link } from 'react-router-dom';

const Dashboard = () => (
  <section className="section">
    <div className="container">
      <div className="section-title">
        <h2>Welcome to Your Dashboard</h2>
        <p>
          Manage your profile, connect with associates, and explore new opportunities on CV‑Connect.
        </p>
      </div>
      {/* Add dashboard widgets or quick links here as needed */}
    </div>
  </section>
);

export default Dashboard;
